import React, { useState, useEffect } from "react";
import { FormControl } from "react-bootstrap";

const WeightInput = ({ value, onChange, label, isInvalid, placeholder, readOnly, isBold, userRoles }) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(value !== undefined && value !== null ? value.toString() : "");
  }, [value]);

  const formatWeight = (input) => {
    if (!input) return "";

    input = input.replace(",", ".");

    input = input.replace(/[^0-9.]/g, "");

    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }

    if (/^0[0-9]/.test(input)) {
      input = input.replace(/^0+/, "");
    }
    if (input.startsWith(".")) {
      input = "";
    }

    if (parts.length === 2 && parts[1].length > 3) {
      parts[1] = parts[1].substring(0, 3);
      input = parts.join(".");
    }

    return input;
  };

  const handleInputChange = (e) => {
    const formattedValue = formatWeight(e.target.value);
    setInputValue(formattedValue);
    onChange(formattedValue);
  };

  const handleBlur = () => {
    if (inputValue.includes(".")) {
      const formattedDecimal = parseFloat(inputValue).toFixed(3);
      setInputValue(formattedDecimal);
      onChange(formattedDecimal);
    }
  };

  return (
    <div className="mb-3">
      {label && (
        <label
          className="mb-1"
          style={{ fontWeight: isBold ? "bold" : "normal" }}
        >
          {label}
        </label>
      )}
      <FormControl
        placeholder={placeholder || "Peso"}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        isInvalid={isInvalid}
        readOnly={readOnly || userRoles}
        autoComplete='off'
      />
      {isInvalid && <div className="invalid-feedback">{label} é obrigatório.</div>}
    </div>
  );
};

export default WeightInput;